// extracted by mini-css-extract-plugin
export var container = "hero-module--container--3PTu0";
export var headingLeft = "hero-module--headingLeft--3o_ul";
export var headingRight = "hero-module--headingRight--22HIK";
export var heroImage = "hero-module--heroImage--QOEHw";
export var heroImageWrap = "hero-module--heroImageWrap--3kJc0";
export var leftQuote = "hero-module--leftQuote--20AlY";
export var leftQuoteWrap = "hero-module--leftQuoteWrap--ySps7";
export var rightQuote = "hero-module--rightQuote--3Q1i1";
export var rightQuoteWrap = "hero-module--rightQuoteWrap--1nDSx";